export default __webpack_public_path__ + "static/Transitional-7d0752590a5b42e6b272d48094fe3658.png";